import { render } from "./ProductCategorization.vue?vue&type=template&id=22b88718&scoped=true"
import script from "./ProductCategorization.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCategorization.vue?vue&type=script&setup=true&lang=js"

import "./ProductCategorization.vue?vue&type=style&index=0&id=22b88718&scoped=true&lang=css"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b88718"],['__file',"resources/js/modules/product-categorization/components/filter/ProductCategorization.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22b88718"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22b88718', __exports__)) {
    api.reload('22b88718', __exports__)
  }
  
  module.hot.accept("./ProductCategorization.vue?vue&type=template&id=22b88718&scoped=true", () => {
    api.rerender('22b88718', render)
  })

}


export default __exports__